import { SAP_CONSUMER_ORIGIN } from 'constants/common';

/**
 * Endpoints que aceptan origin. El método evita marcar rutas parecidas
 * que no están en el contrato (pdf, DELETE, reagendo, etc.).
 */
const ORIGIN_CONTRACT = Object.freeze([
  ['GET', /^\/users\/clients\/[^/]+$/],
  ['GET', /^\/users\/clients\/[^/]+\/otp$/],
  ['GET', /^\/users\/clients\/[^/]+\/link\/otp$/],
  ['POST', /^\/users\/clients\/[^/]+\/verify$/],
  ['POST', /^\/users\/clients\/[^/]+\/link\/verify$/],
  ['PATCH', /^\/users\/clients\/address$/],
  ['GET', /^\/users\/clients\/address$/],
  ['POST', /^\/users\/signup\/otp$/],
  ['POST', /^\/users\/signup\/complete$/],
  ['POST', /^\/users\/clients\/complete-onboarding$/],
  ['PUT', /^\/users\/identifier\/confirm$/],
  ['POST', /^\/users\/clients\/referral-code$/],
  ['GET', /^\/clients\/states$/],
  ['GET', /^\/clients\/colonies$/],
  ['GET', /^\/clients\/municipalities$/],
  ['GET', /^\/clients\/colonies\/postal-codes\/[^/]+$/],
  ['GET', /^\/clients\/collections$/],
  ['GET', /^\/digitalization\/contracts$/],
  ['GET', /^\/digitalization\/sections$/],
  ['GET', /^\/digitalization\/sales$/],
  ['GET', /^\/digital-loan\/validate-black-list$/],
  ['POST', /^\/digital-loan\/[^/]+\/amount-and-scoring$/],
  ['POST', /^\/digital-loan\/[^/]+\/schedule-visit$/],
  ['POST', /^\/payments\/paycash\/references$/],
  ['POST', /^\/payments\/paycash\/references\/batch$/],
  ['POST', /^\/payments\/bancomer\/references$/],
  ['POST', /^\/payments\/bancomer\/references\/batch$/],
  ['POST', /^\/payments\/puntored\/references$/],
  ['POST', /^\/payments\/puntored\/references\/batch$/],
  ['POST', /^\/mercadopago\/single-payment$/],
  ['POST', /^\/mercadopago\/multiple-payment$/],
  ['GET', /^\/stores\/catalog$/],
  ['GET', /^\/stores\/sections$/],
  ['GET', /^\/loyalty-points\/points$/],
  ['GET', /^\/loyalty-points\/promotions$/],
  ['POST', /^\/loyalty-points\/promotions\/[^/]+$/],
  ['GET', /^\/loyalty-points\/coupon\/status$/],
]);

/** Path sin query. Acepta URL absoluta o relativa. */
export function requestPath(url = '') {
  const raw = String(url || '').split('#')[0].split('?')[0];
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).pathname;
    } catch (error) {
      return raw || String(error?.message || '');
    }
  }
  return raw.startsWith('/') ? raw : `/${raw}`;
}

export function matchesOriginContract(method, url) {
  const verb = String(method || 'GET').toUpperCase();
  const path = requestPath(url);
  return ORIGIN_CONTRACT.some(([expected, pattern]) => (
    expected === verb && pattern.test(path)
  ));
}

/**
 * Portal web: origin=2 en la instancia (comportamiento ya existente).
 * App nativa: origin=1 solo en el contrato, para no marcarlo en el resto.
 * null = no agregar el parámetro.
 */
export function resolveConsumerOrigin({ isWeb, method, url } = {}) {
  if (isWeb) return SAP_CONSUMER_ORIGIN.PORTAL;
  if (matchesOriginContract(method, url)) return SAP_CONSUMER_ORIGIN.APP;
  return null;
}

/**
 * Agrega origin sin tocar el body ni el query que ya va en la url.
 */
export function applyConsumerOrigin(config, { isWeb, skipOrigin } = {}) {
  if (skipOrigin || !config) return config;
  const origin = resolveConsumerOrigin({
    isWeb,
    method: config.method,
    url: config.url,
  });
  if (origin == null) return config;
  return {
    ...config,
    params: { ...config.params, origin },
  };
}
